/**
 * @file index.tsx
 *
 * @fileoverview Renders a tag to check the status of a page in statuscake.
 * Renders the default tag this will be overriden by any error page that is rendered (if there is an error e.g. 500.tsx)
 */
import React from 'react';
import Head from 'next/head';

export default function StatuscakeCheck() {
  return (
    <Head>
      <meta name="owner" content="jobiqo" key="jd-owner" />
    </Head>
  );
}
